// src/constants/entityType.ts
export const EntityType = {
  PERSON_NATURAL: 1,
  PERSON_LEGAL: 2,
  CONSUMER_FINAL: 3,
  GENERAL: 5, // (sujeto excluido NO aplica aquí)
} as const;
